// test1266
(1266 && 0);
